import { useTranslations } from 'next-intl'
import React from 'react'

import LoadingSpinner from 'component/block/loading/spinner'
import { ScrollArea } from 'component/ui/scroll-area'
import { twc } from 'util/cn'

const Caption = twc.div`relative flex h-[100px] items-center justify-center px-[16px] text-center text-md text-label-l2`
Caption.displayName = 'Caption'

interface IListContainer {
  children: React.ReactNode
  showLoading?: boolean
  showNoResult?: boolean
  keyword?: string
  onScroll?: (e: React.UIEvent<HTMLDivElement>) => void
}
const LocationListContainer = (props: IListContainer) => {
  const { children, onScroll, showLoading, showNoResult, keyword } = props
  const t = useTranslations()

  return (
    <ScrollArea
      onScroll={onScroll}
      className='h-full max-h-[606px] overflow-hidden rounded-b-[12px] playsee-mb:max-h-[calc(100%_-_64px)]'
      viewportClassName='max-h-[inherit] playsee-mb:max-h-full overscroll-y-contain'
    >
      {showLoading && (
        <Caption>
          <LoadingSpinner />
        </Caption>
      )}
      {showNoResult && (
        <Caption>
          {t('feed.place_no_match', {
            search_term: keyword
          })}
        </Caption>
      )}

      {children}
    </ScrollArea>
  )
}

export default LocationListContainer
